import React, {useContext} from 'react';
//import images
import EmmaImg from '../img/about/EmmaNew.jpg';
import EmmaCircle from '../img/about/EmmaCircleNew.png';

//import link
import { Link } from 'react-router-dom';

//import motion
import { motion } from 'framer-motion';
// import transition
import {transition1} from '../transitions'
import { CursorContext } from '../context/CursorContext';

const About = () => {
  const {mouseEnterHandler, mouseLeaveHandler} = useContext(CursorContext);
  return <motion.section 
    initial={{ opacity:0, y: '100%' }} 
    animate={{ opacity:1, y:0 }} 
    exit={{ opacity:0, y:'100%' }}
    transition={transition1}
    className='section overflow-scroll'>
    <div className='container mx-auto relative pt-[200px] md:pt-[140px] h-full pb-15'>
      {/*text & img wrapper */}
      <div className='flex flex-col md:flex-row  h-full items-center md:items-start
      justify-center gap-x-16 gap-y-8 text-center pb-100'>
        <div className='hidden md:flex bg-blue-200 max-w-md lg:max-h-full lg:order-none'>
          <img className='object-cover h-full w-full'
          src={EmmaImg} alt='' />
        </div>
        <div className='flex md:hidden max-w-sm h-[40%] justify-center'>
          <img className=""
          src={EmmaCircle} alt='' />
        </div>
        {/*text*/}
        <motion.div 
          initial={{ opacity:0, y: '-80%' }} 
          animate={{ opacity:1, y:0 }} 
          exit={{ opacity:0, y:'0%' }}
          transition={transition1}
          onMouseEnter={mouseEnterHandler}
          onMouseLeave={mouseLeaveHandler}
          className='lg:w-auto z-10 flex flex-col
          justify-center items-center md:items-start md:text-left'>
          <h1 className='h1 text-[18px] md:text-[34px]'>
            Welcome! <br /> Bienvenue! 
          </h1>
          <p className='font-secondary font-light text-sm mb-6 w-full pl-5 pr-5 md:pl-0 md:pr-0 md:max-w-md'>
          I’m Emma Tysinger, a photographer based in Paris, France, capturing captivating photos for hospitality, travel, and destination-focused brands.
          <br />
          <br />

          My work is rooted in a love of travel, architecture, and discovering beautiful places. From quiet corners of Paris to mountain landscapes and thoughtfully designed interiors, I aim to capture places in a way that feels elevated, inviting, and memorable. I began photography in Vermont, documenting my backyard and family trips. That early curiosity grew into my passion for travel and visual storytelling.

          I photograph hotels, interiors, destinations, and urban environments, along with portraits and group sessions that feel natural and connected.

          When I’m not behind the camera, you’ll likely find me skiing, wandering through new neighborhoods, or playing the piano. If you’d like to discuss a shoot or collaboration, I’d love to hear from you.
          </p>
          <br />
          <Link
            to={'/'}
            className='group inline-flex items-center gap-3 font-secondary text-sm uppercase tracking-[0.2em] text-primary'
          >
            <span className='border-b border-primary/40 pb-1 transition-colors group-hover:border-primary'>
              View my work
            </span>
            <span
              aria-hidden='true'
              className='transition-transform duration-300 group-hover:translate-x-1'
            >
              &rarr;
            </span>
          </Link>
        </motion.div>
        
        
      </div>
    </div>
    <footer className='flex w-full justify-center items-center pt-16 pb-8'>
      <div className='text-sm text-primary'>Copyright © 2026</div>
    </footer>
  </motion.section>;
};

export default About;
